import { gql } from "@apollo/client"

export const GET_ORDER_PDF_URL = gql`
  query getOrderPdfUrl($orderId: ID!) {
    order(orderId: $orderId) {
      pdfUrl
    }
  }
`
